<template>
  <v-col class="pa-6">
    <!-- sales data table -->
    <repair-table :key="index" url-api="/repair" :headers="headers">
      <!-- New new repair -->
      <template #urlCreate>
        <v-btn
          class="warning"
          @click.prevent="
            $router.push({
              name: 'RepiarForm',
            })
          "
        >
          <v-icon>mdi-plus</v-icon>
          New Repair
        </v-btn>
      </template>
      <!-- end -->

      <!-- Charges -->
      <template #charges="{ item }">
        {{ item.charges | currency }}
      </template>

      <!-- end -->

      <!-- Prepaid amount -->
      <template #prePaid="{ item }">
        <span class="success--text">{{ item.prePaid | currency }}</span>
      </template>

      <!-- end -->

      <!-- Due Charges -->
      <template #due="{ item }">
        <span class="error--text">{{ item.due | currency }}</span>
      </template>

      <!-- end -->

      <!-- Repair state toggle -->
      <template #status="{ item }">
        <v-edit-dialog>
          {{ item.status ? "Complete" : "Pending" }}

          <template #input>
            <v-select
              v-model="item.status"
              :items="toggleStates"
              item-text="title"
              item-value="value"
              label="Change repair status"
              placeholder="Repair status"
              cols="3"
              @change="toggleState(item)"
            />
          </template>
        </v-edit-dialog>
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template #columnaction="{ item }">
        <!-- Repair edit -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'RepiarForm',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Repair info Edit</span>
        </v-tooltip>
        <!-- end -->

        <!-- Slip Print -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'RepiarPrint',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-printer
              </v-icon>
            </v-btn>
          </template>
          <span>Print Recipient</span>
        </v-tooltip>
        <!-- end -->

        <!-- Product remove -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn small icon @click="warningRepairRemove(item)" v-on="on">
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </repair-table>

    <!-- end data table -->

    <!-- Repair remove warning -->
    <v-dialog v-model="repairRemoveWarning" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="repairRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="removeRepair">
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import RepairDataTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "repair-table": RepairDataTable,
  },
  data() {
    return {
      repair: [],
      repairRemoveWarning: false,
      index: 1,
      toggleStates: [
        { title: "Complete", value: 1 },
        { title: "Pending", value: 0 },
      ],
      headers: [
        {
          text: "Added At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Reference",
          sortable: true,
          value: "key",
        },
        {
          text: "Name",
          sortable: true,
          value: "name",
        },

        {
          text: "Device Name",
          sortable: false,
          value: "deviceName",
        },
        {
          text: "SN #",
          sortable: false,
          value: "sNumber",
        },
        {
          text: "Status",
          sortable: true,
          value: "status",
          slot: "status",
        },

        {
          text: "Charges",
          sortable: true,
          value: "charges",
          slot: "charges",
        },
        {
          text: "Paid",
          sortable: true,
          value: "prePaid",
          slot: "prePaid",
        },
        {
          text: "Due",
          sortable: true,
          value: "due",
          slot: "due",
        },
        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    toggleState(repair) {
      window.axios
        .post("/toggle-repair-status/" + repair.id, { status: repair.status })
        .then((response) => {
          this.feedback(response.data.message);
        });
    },

    removeRepair() {
      window.axios
        .delete("/repair/" + this.$data.repair.id)
        .then((response) => {
          this.feedback(response.data.message);
          this.repairRemoveWarning = false;
          this.$data.index++;
        });
    },

    warningRepairRemove(repair) {
      this.repair = repair;
      this.repairRemoveWarning = true;
    },
  },
};
</script>
